module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/ContentAndImage-c09fbeb9ab4cecdb2ec9fd4f374565dc.png";